import { SMBFractionTypes } from 'partner360/entities/planning/model'

import { IPartnerFinSobRow } from '../../model/types'

/** One canonical GTM row from the planning-shaped payload. The API can return the same logical
 * value both as a Total and split into SMB/EU rows; summing all representations counts it twice. */
export const isCanonicalFinSobRow = (row: IPartnerFinSobRow): boolean =>
  !row.isDirect && !row.isRollUp && (!row.smbFraction || row.smbFraction === SMBFractionTypes.Total)
